import { Input } from 'antd';

const { Search } = Input;

const TooltipSearch = ({ isVisible }) => {
  return (
    <div className={`header-toolip search ${isVisible ? 'visible' : ''}`} >
      <div className="content-toolip_search">
        <p className="source-16 c-dark mt-5 mb-10">¿Qué estas buscando?</p>
        <Search placeholder="Inversiones 123456…" />
      </div>
    </div>
  )
}

export default TooltipSearch
